import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import FinanceProductForm from "../FinanceProductForm";
import FinanceProductFormBody from "../FinanceProductFormBody";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import FinanceProduct from "../../../../model/financeProduct/FinanceProduct";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {FinanceProduct} data new finance product object.
	 */
	onSubmit: (data: FinanceProduct) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type IState = BaseFormViewState<FinanceProductForm>;

export default class CreateFinanceProductFormView extends BaseFormView<FinanceProductForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: FinanceProductForm.createEmpty(),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<FinanceProductFormBody form={this.state.form}
										onFieldChange={this.onFieldChanged}
										onFieldCompleted={this.onFieldCompleted}
										onFocusChange={this.onFocusChange}
										onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Create Finance Product"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}